import APIService from 'services/APIService'

const api = APIService()

export const fetchTourProgress = () => api.get('/tours/progress')

export const markTourProgressRemote = (key, status, version, extra = {}) =>
  api.post(`/tours/${encodeURIComponent(key)}/progress`, { status, version, ...extra })
